<template>
  <div :loading="loading">
    <div class="fixedButton" style="margin-top:10px">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button class="examineButton" status="primary" @click="submint()">保存</vxe-button>
    </div>
    <!-- 活动信息 -->
    <div class="CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine" :style="`height:${$store.state.app.height - 70}px;`">
      <activityInformation :data="activity" :disabled="true" :special-budget="specialBudgetFlag" />
      <registerInformation
        ref="registerInformation"
        :data="signData"
        :activity="activity"
        :file-list.sync="fileList"
        :disabled-edit="!specialBudgetFlag"
        @setStrainsJingArr="setStrainsJingArr"
      />
      <!-- <clientTarget
        ref="clientTarget"
        :apply.sync="signData"
        :activity.sync="activity"
        :car-series-list.sync="carSeriesList"
        :sub-series.sync="SelectLists.subSeries"
      /> -->
      <!-- <div style="height: 100px; width: 100%; padding: 0px 40%">
        <vxe-button v-loading.fullscreen.lock="fullscreenLoading" style="width: 250px; margin-top: 10px" type="primary" icon="el-icon-check" @click="submint('signUpForm')">提交</vxe-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { findDealerActById, getActApplyDetail, saveApplyInfo, savePlanCustomers, findFileInfo } from '@/api/actPlan'
import activityInformation from './components/activityInformation'
import registerInformation from './components/registerInformation'
// import clientTarget from './components/clientTarget'
// import { setInitImg } from '@/utils/Picture/transferFile'

export default {
  name: 'EditSignActivity',
  components: {
    activityInformation,
    registerInformation,
    // clientTarget
  },
  data() {
    return {
      loading: false,
      fullscreenLoading: false,
      modelTableBase: {
        data: [],
        loading: false,
        selection: []
      },
      activity: {},
      signData: {
        id: null, // 提报活动id
        planId: null, // 活动计划id
        planDealerId: null, // 活动下发对象经销商id，不是经销商id
        // regionId: '', //经理部
        dealerShortName: '', //经销商
        actMonth: null, // 申报月份
        planApplyName: null, // 提报活动提报名
        applyTime: null, // 提报时间
        itemType: 1, // 提报类型
        planStartTime: null, // 提报活动计划开始时间
        planEndTime: null, // 提报活动计划结束时间
        executeNums: null, // 执行数量
        actBudget: null, // 活动预算
        strainsName: '', // 品系
        strainsCode: '', // 品系编码
        strainsNameList: [], // 品系列表
        strainsCodeList: [], // 品系编码列表
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        strainsArr: [], // 品系编码数组
        applyStatus: null
      },
      fileList: [], // 文件
      programmeNames: [],
      fileInfoList: [],
      SelectLists: {},
      specialBudgetFlag: false, // 活动提报名称编辑
      carSeriesList: []
    }
  },
  created() {
    this.SelectListsFun()
    if (this.$route.params.id) {
      this.signData.id = this.$route.params.id
      // 获取提报详情
      this.getMarketactivityById()
    }
  },
  methods: {
    // 提交申报车系目标
    addStoreActivityCar() {
      const data = {
        planApplyId: this.signData.id,
        customers: this.$refs.clientTarget.data.data
      }
      this.loading = true
      savePlanCustomers(data).then(res => {
        if (res.code === 1) {
          this.loading = false
          this.$message.success('保存成功')
          this.ReturnFun()
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    // 新增提报数据
    addMarketactivity() {

      // this.signData.strainsCode = this.signData.strainsArr.toString()
      // 通过refs获取活动表单数
      const activityForm = this.$refs.registerInformation.$refs.activityForm.getActivityForm()
          //  数据是不是不完整
          // 定义需要删除的属性数组  遍历并删除activityForm中指定的属性
      let propsToRemove = ['regionId','actMonth','planApplyName','planStartTime','planEndTime','actBudget'];
      propsToRemove.forEach(prop => {
        delete activityForm[prop];
      });
      console.log(this.signData,activityForm,'传入的数据');
      const params = Object.assign(this.signData, activityForm)
      console.log(params,'---保存最终处理的数据');

      this.loading = true
      saveApplyInfo(params).then(res => {
        if (res.code === 1 && res.data) {
          // this.signData = res.data
          // this.saveFile()
          // this.addStoreActivityCar()
          this.$message.success('保存成功')
          this.ReturnFun(1)
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    saveFile() {
      if (this.fileList.length < 1) {
        return
      }
      const formData = new FormData()
      if (this.fileList) {
        this.fileList.forEach(val => {
          if (val.raw) {
            formData.append('file', val.raw)
          }
        })
      }
      const data = {
        type: 'actPlanApply',
        code: this.signData.planApplyCode
      }
      const param = JSON.stringify(data)
      formData.append('params', new Blob([param], { type: 'application/json' }))
      // uploadPlanFiles(formData).then()
    },
    // 提交数据
    submint() {
      this.$refs.registerInformation.$refs['signUpForm'].validate(async valid => {
        if (valid) {
          const res = await this.$refs.registerInformation.$refs.activityForm.$refs['ruleForm'].validate().catch((err)=>{return err})
          if (!res) {
            return  this.$message.error('请检查表单，完成所有必填项目！')
          }

          if (this.$refs.registerInformation.$refs.activityForm.vehicleModelAndQuantity.length === 0 &&
              this.$refs.registerInformation.$refs.activityForm.vehicleModelCheck === 1) {
            return this.$message.error('请选择主推车型及数量！')
          }

          // 校验合计大于0
          const activityForm = this.$refs.registerInformation.$refs.activityForm.getActivityForm()
          const totalCost = Number(activityForm.totalCost)
          if (!totalCost || totalCost <= 0) {
            this.$message.warning('您申请的核销金额为0，请重新填写后再提交。')
            return
          }

          // 调用保存
          this.addMarketactivity()
        } else {
          this.$message.error('请检查表单，完成所有必填项目！')
          return false
        }
      })
    },
    setStrainsJingArr(val) {
      console.log(val,'点击');
      this.signData.regionId = val
    },
    // 获取提报详情
    getMarketactivityById() {
      this.loading = true
      getActApplyDetail(this.signData.id).then(res => {
        if (res.code === 1 && res.data) {
          this.signData = res.data
          console.log(this.signData,"this.signData11111")
          this.signData.regionId = Number(res.data.regionId)  //经理部
          this.signData.dealerName = res.data.dealerName
          this.signData.dealerShortName = res.data.orgName
          this.getActById(this.signData.planDealerId)
          // 初始化strainsCode
          this.$set(this.signData, 'strainsArr', []) // 解决选择器无法正常选择的问题
          // this.signData.strainsArr = this.signData.strainsCode.split(',')
          this.getFileInfo(this.signData.planApplyCode)
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PeriodBudgetCode', 'subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取活动详情
    getActById(id) {
      const data = {
        id: id,
        planApplyId: this.signData.id
      }
      this.loading = true
      findDealerActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          this.handleSpecialBudget()
          this.getCarSeriesList()
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 处理特殊预算类型（日常推广和新入网）
    handleSpecialBudget() {
      if (this.activity.budgetTypeCode === '1' || this.activity.budgetTypeCode === '13') {
        this.specialBudgetFlag = true
      }
    },
    getCarSeriesList() {
      if (this.activity.strainsCarCode) {
        this.carSeriesList = this.activity.strainsCarCode.split(',')
      }
    },
    // 获取文件信息
    getFileInfo(code) {
      findFileInfo(code).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    initFile() {
      if (this.fileInfoList.length < 1) {
        return
      }
      this.fileInfoList.forEach(item => {
        if (item.module === 'actPlanApply') {
          this.fileList.push(item)
          // getFiles(item).then(res => {
          //   const file = setInitImg(res, item.name)
          //   this.fileList.push(file)
          // })
        }
      })
    },
    ReturnFun() {
      // this.$deleteBeforeRouter(this)
      // this.$router.push('/market_activity/center/signIndex')
      if(this.$route.query.type === 'myToDolistShiChangTiBao'){
        // 跳转路由
        this.$closePage('/terminalActivity/signDetails', '/terminalActivity/myToDolist')
      }else {
        this.$closePage('/terminalActivity/editSignActivity', '/terminalActivity/signIndex')
      }

    },
    // 计算集客目标和订单目标是否等于下发的目标
    countTarget(value) {
      const customerList = this.$refs.clientTarget.data.data
      if (value === 0) {
        // 使用 reduce 方法计算属性的总和
        const customerSum = customerList.reduce(function(accumulator, current) {
          return accumulator + Number(current.customerTarget)
        }, 0) // 初始值为 0
        return this.activity.customerTarget === customerSum
      } else {
        const orderSum = customerList.reduce(function(accumulator, current) {
          return accumulator + Number(current.orderTarget)
        }, 0) // 初始值为 0
        return this.activity.orderTarget === orderSum
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fixedButton {
  width: 100%;
  margin: 0;
  padding: 0 5px 5px;
  .examineButton {
    margin: 0 10px 0 0;
  }
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  // padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
  }
}
</style>
